module.exports = {
    jlsRegisterViewLoaded: 1800,

    jlsTypedAlreadyExistingEmail: 1801,
    jlsAlreadyExistingUserClickedLoginLink: 1802,

    jlsTypedFederatedEmail: 1803,
    jlsFederatedUserClickedLoginLink: 1804,

    jlsGetStartedButtonClickedButFormIsInvalid: 1805,
    jlsGetStartedButtonClickedButFormIsInvalidDueToTcsCheckboxNotChecked: 1806,
    jlsGetStartedButtonClickedAndFormIsValid: 1807,

    jlsSuccessfulRegistrationAtClsSide: 1808,
    jlsSuccessfulRegistrationAtClsSideSendMeProductInformationUnchecked: 1809,
    jlsFailedRegistrationAtClsSide: 1810,

    jlsTermsLinkClicked: 1811,
    jlsPrivacyPolicyLinkClicked: 1812,
    jlsChooseOtherwiseLinkClicked: 1813,
    jlsSendMeProductInformationUnchecked: 1814
};


/** WEBPACK FOOTER **
 ** ./src/constants/tracking-action.js
 **/